var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIxell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1180.000000pt",
    height: "708.000000pt",
    viewBox: "0 0 1180.000000 708.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,708.000000) scale(0.100000,-0.100000)",
    fill: "#413A38",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8200 3565 l0 -1945 445 0 445 0 0 1945 0 1945 -445 0 -445 0 0 -1945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9240 3565 l0 -1945 445 0 445 0 0 1945 0 1945 -445 0 -445 0 0 -1945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076 5364 c-142 -34 -296 -153 -364 -281 -40 -76 -72 -197 -72 -272 1 -149 62 -301 164 -404 108 -110 229 -165 381 -174 275 -16 522 165 590 432 18 69 20 192 4 267 -42 201 -216 380 -424 433 -73 18 -200 18 -279 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6465 4199 c-183 -33 -342 -90 -484 -174 -337 -199 -573 -527 -657 -915 -25 -118 -30 -353 -9 -485 31 -200 113 -406 228 -574 66 -97 250 -282 347 -348 147 -100 332 -179 510 -218 102 -22 342 -31 453 -16 190 25 379 91 540 188 99 60 247 182 310 256 l48 56 -28 20 c-15 12 -183 131 -373 265 l-345 244 -46 -34 c-89 -65 -154 -88 -263 -92 -120 -5 -201 14 -284 67 -56 37 -132 112 -132 131 0 7 300 10 874 10 778 0 875 2 880 15 3 9 11 67 17 130 34 333 -78 700 -298 974 -204 256 -519 441 -842 495 -103 17 -361 20 -446 5z m406 -931 c42 -19 98 -57 129 -86 l55 -51 -372 -1 c-219 0 -373 4 -373 9 0 16 93 92 145 119 88 45 123 52 236 49 97 -3 112 -6 180 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 2865 l0 -1235 435 0 435 0 0 1235 0 1235 -435 0 -435 0 0 -1235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 4096 c0 -3 189 -291 420 -641 l420 -636 -107 -152 c-59 -84 -246 -348 -416 -587 -170 -239 -312 -441 -314 -447 -4 -10 110 -13 550 -13 l555 0 123 172 c67 95 130 183 140 196 17 22 17 22 155 -173 l137 -195 575 0 c458 0 573 3 565 13 -73 94 -853 1178 -853 1185 0 5 194 291 430 636 237 345 430 631 430 637 0 5 -221 9 -573 9 l-573 0 -135 -205 c-74 -113 -138 -204 -142 -202 -5 1 -62 92 -127 202 l-118 200 -571 3 c-314 1 -571 0 -571 -2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIxell);
export default __webpack_public_path__ + "static/media/brand_ixell.13ba8f9372d20e905e5e9edabf101c9a.svg";
export { ForwardRef as ReactComponent };